import { render, staticRenderFns } from "./PopularItems.vue?vue&type=template&id=6f92804d&"
import script from "./PopularItems.vue?vue&type=script&lang=ts&"
export * from "./PopularItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports